export enum LoadingState {
  CHECKING_UPDATES = 'CHECKING_UPDATES',
  DOWNLOADING_UPDATE = 'DOWNLOADING_UPDATE',
  INSTALLING_UPDATE = 'INSTALLING_UPDATE',
  LOADING = 'LOADING',
}

export const LOADING_STATE_MESSAGES: Record<LoadingState, { sk: string; en: string }> = {
  [LoadingState.CHECKING_UPDATES]: {
    sk: 'Kontrola aktualizácií...',
    en: 'Checking for updates...',
  },
  [LoadingState.DOWNLOADING_UPDATE]: {
    sk: 'Sťahovanie novej verzie...',
    en: 'Downloading new version...',
  },
  [LoadingState.INSTALLING_UPDATE]: {
    sk: 'Inštalácia aktualizácie...',
    en: 'Installing update...',
  },
  [LoadingState.LOADING]: {
    sk: 'Načítavam...',
    en: 'Loading...',
  },
};
